import React, { useState, useEffect } from "react";
import { useIntl } from "react-intl";
import { Row, Col } from "antd";

import TableHeader from "../../app/generic/tableHeader";
import TooltipButton from "../../app/generic/tooltipButton";
import SelectAllButton from "../../app/generic/selectAllButton";
import FilterButton from "../../app/generic/tableFilter/filterButton";

function ConsignmentListHeader({
  sentList,
  showFilter,
  bulkDelete,
  allSelected,
  onSendClick,
  disableSend,
  trackingList,
  onPrintClick,
  onSelectClick,
  onDeleteClick,
  onFilterClick,
  onExportClick,
  disabledOptions,
}) {
  const intl = useIntl();
  const [title, setTitle] = useState();
  useEffect(() => {
    setTitle(
      trackingList
        ? intl.formatMessage({
            id: "consignment.tracking",
            defaultMessage: "Sledování zásilek",
          })
        : sentList
        ? intl.formatMessage({
            id: "consignment.sent",
            defaultMessage: "Zásilky odeslané do DHL",
          })
        : intl.formatMessage({
            id: "consignment.notSent",
            defaultMessage: "Rozpracované a neodeslané zásilky",
          })
    );
  }, [intl, sentList, trackingList]);

  return (
    <TableHeader
      title={title}
      left={
        <Row type="flex" gutter={10}>
          <Col>
            <SelectAllButton
              allSelected={allSelected}
              onClick={onSelectClick}
            />
          </Col>
          <Col>
            <FilterButton showFilter={showFilter} onClick={onFilterClick} />
          </Col>
        </Row>
      }
      right={
        sentList ? (
          <>
            <TooltipButton
              text={intl.formatMessage({
                id: "consignment.exportConsignments",
                defaultMessage: "Export",
              })}
              icon="export"
              onClick={onExportClick}
              disabled={disabledOptions}
              className="header-button-margin"
              title={intl.formatMessage({
                id: "consignment.exportConsignments.title",
                defaultMessage: "export zásilek do excelu",
              })}
            />
            <TooltipButton
              text={intl.formatMessage({
                id: "messages.print",
                defaultMessage: "Tisk",
              })}
              icon="printer"
              onClick={onPrintClick}
              disabled={disabledOptions}
              title={intl.formatMessage({
                id: "consignment.printTitle",
                defaultMessage: "zobrazí nabídku tisku k zásilkám",
              })}
            />
          </>
        ) : (
          <>
            <TooltipButton
              text={
                bulkDelete
                  ? intl.formatMessage({
                      id: "consignment.dropConsignments.drop",
                      defaultMessage: "Smazat zásilky",
                    })
                  : intl.formatMessage({
                      id: "consignment.dropConsignments",
                      defaultMessage: "Smazání",
                    })
              }
              icon="delete"
              onClick={onDeleteClick}
              disabled={disabledOptions}
              className="header-button-margin"
              title={
                bulkDelete
                  ? intl.formatMessage({
                      id: "consignment.dropConsignments.end",
                      defaultMessage: "kliknutím smažete vybrané zásilky",
                    })
                  : intl.formatMessage({
                      id: "consignment.dropConsignments.title",
                      defaultMessage: "hromadné smazání zásilek",
                    })
              }
            />
            <TooltipButton
              text={intl.formatMessage({
                id: "consignment.sendConsignments",
                defaultMessage: "Odeslat do DHL",
              })}
              onClick={onSendClick}
              disabled={disabledOptions || disableSend}
              title={intl.formatMessage({
                id: "consignment.sendConsignmentsTitle",
                defaultMessage: "odešle validní zásilky do DHL",
              })}
            />
          </>
        )
      }
    />
  );
}

export default ConsignmentListHeader;
